import { IOrder } from '@/store/ducks/order/types';

export const setLocalOrder: (order: IOrder | string) => void = (order) => {
  if (
    typeof order === 'object' &&
    order !== null &&
    'id' in order &&
    'company_id' in order &&
    'dst_shop_id' in order
  ) {
    const orderBase = btoa(`${order.id};${order.company_id};${order.dst_shop_id}`);
    localStorage.setItem('order', orderBase);
  }
};
